import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../../provider/AuthProvider';

import { useLocation, useNavigate } from 'react-router';
import gameAPI from '../../../../api/gameAPI';
import MasterPage from '../../../../layouts/MasterPage';
import PopupBox from '../../../../components/PopupBox';
import AuthenticationManager from '../../../../services/StorageJWT';
const tips = [
  'arian',
  'broshor',
  'magazine',
  'card',
  'money',
  'money2',
'divorce',
  
  'postal2',
 'postal',
  

  'birthday',
  'picture',
  'table',
  'plane',
];
const tipsIcon = [
  '/images/two/3.svg',
  '/images/two/2.svg',
  '/images/two/1.svg',
  '/images/two/4.svg',
  '/images/two/6.svg',
  '/images/two/5.svg',
  '/images/two/8.svg',
  '/images/two/7.svg',
  '/images/two/9.svg',
  '/images/two/10.svg',
  '/images/two/12.svg',
  '/images/two/11.svg',
  '/images/two/13.svg',
];
const Help2 = () => {
  const [showTitleAnswer, setShowTitleAnswer] = useState('');
  const [showTextAnswer, setShowTextAnswer] = useState('');
  const [confirm, setConfirm] = useState(0);
  const [guids, setGuids] = useState([]);
  const [userGuids, setUserGuids] = useState([]);
  const [typeFa, setTypeFa] = useState();
  const [styleButton, setStyleButton] = useState([null, null, null, null]);
  const [activeTip, setActiveTip] = useState(-1);
  const [errorText, setErrorText] = useState('');
  const [show, setShow] = useState(false);
  const { token } = useAuth();
  const auth = new AuthenticationManager();
  const navigate = useNavigate();
  let statePrev = useLocation();
  const setType = (type) => {
    switch (type) {
      case 'arian':
        setTypeFa('معمای آرین');
        break;
    }
  };
  const init = () => {
    setShowTitleAnswer('');
    setShowTextAnswer('');
    setConfirm(0);
    setActiveTip(-1);
    setErrorText('');
    setShow(false);
    setStyleButton([null, null, null, null]);
  };
  useEffect(() => {
    init();
    gameAPI.help(statePrev.state.type, token).then((res) => {
      setGuids(res.guids);
      setUserGuids(res.user_guids);
    });
    setType(statePrev.state.type);
  }, [statePrev]);

  const checkExistBefore = (tip) => {
    var _status = false;
    userGuids.map((guid) => {
      if (guid.tip == tip) {
        setShowTextAnswer(guid.answer);
        setShowTitleAnswer(guid.title);
        _status = true;
      }
    });
    return _status;
  };
  const showAnswer = (index, guid) => {
    var _styleButton = styleButton;

    for (var i = 0; i < _styleButton.length; i++) {
      if (i == index) _styleButton[i] = 'red-color-1 ';
      else _styleButton[i] = null;
    }
    setStyleButton(_styleButton);
    setActiveTip(index);

    if (checkExistBefore(guid.tip) == true) {
      setConfirm(2);
    } else {
      setShowTitleAnswer(guid.title);
      setConfirm(1);
    }
  };
  const getAnswer = () => {
    gameAPI
      .getAnswer(guids[activeTip].id, token)
      .then((res) => {
        setShowTitleAnswer(res.guid.title);
        setShowTextAnswer(res.guid.answer);
        setConfirm(2);
        setUserGuids([...userGuids, { ...res.guid }]);
        // console.log(userGuids,44444)
        if(res?.point)
         auth.updatePoint(res.point);
      })
      .catch((e) => {
        if (e?.response?.status == 422) {
          setShow(true);
          setErrorText('امتیاز شما کافی نمی باشد');
        }

        console.log(e);
      });
  };
  const styleTextCheck = (tip, index) => {
    var style = '';
    userGuids.map((guid) => {
      if (guid.tip == tip && index == activeTip) style = 'text-danger';
      else if (guid.tip == tip) style = 'text-muted';
    });
    return style;
  };
  const stylePointCheck = (tip, index) => {
    var style = '';
    userGuids.map((guid) => {
      if (guid.tip == tip) style = 'd-none';
    });
    return style;
  };
  const backTip = () => {
    // alert(statePrev.state.type)
    var res = tips.indexOf(statePrev.state.type);
    navigate('/two/helps', { state: { type: tips[res - 1] } });
  };
  const nextTip = (tip) => {
    var res = tips.indexOf(statePrev.state.type);

    navigate('/two/helps', { state: { type: tips[res + 1] } });
  };
  return (
    <MasterPage>
      <div className="">
        <div className="structure-page login p-3 body   ">
          <div className="helps2">
            <div className='divider'>\\\\\\\\</div>
            <div
              className={`d-grid text-center answer  z-index-2	 z-2 ${
                confirm == 0 ? 'invisible' : ""
              }`}
            >
              {confirm === 1 && <h4 className="fw-bold text-white"> {showTitleAnswer}</h4>}
              {confirm === 1 && (
                <div className='text-white'>از مشاهده این راهنمایی اطمینان دارید؟</div>
              )}
              {confirm === 1 && (
                <div className="d-flex gap-3 mt-2">
                  <button
                    className="btn btn-show pt-2 pb-2 mb-4"
                    onClick={getAnswer}
                  >
                    مشاهده
                  </button>
                  <button
                    onClick={() => setConfirm(-1)}
                    className="btn btn-cancel pt-2 pb-2 mb-4 text-white"
                  >
                    انصراف
                  </button>
                </div>
              )}
              {confirm === 2 && (
                <div className='text-white'>
                  {/* <h4>{showTitleAnswer}</h4> */}
                <div className='hint-text'  dangerouslySetInnerHTML={{__html: showTextAnswer}}></div>  
                </div>
              )}
            </div>

            <div className="options">
              <div className="d-flex align-items-center overflow-hidden ">
                <img
                  role="button"
                  onClick={nextTip}
                  src="/icons/arrow-right2.svg"
                  className={`${
                    tips.indexOf(statePrev.state.type) !== tips.length - 1
                      ? null
                      : 'invisible'
                  }`}
                />

                <img
                  src={tipsIcon[tips.indexOf(statePrev.state.type)]}
                  style={{ height: 100 }}
                  className=" m-auto mb-2 "
                />
                <img
                  role="button"
                  onClick={backTip}
                  src="/icons/arrow-left2.svg"
                  className={`${
                    tips.indexOf(statePrev.state.type) !== 0
                      ? null
                      : 'invisible'
                  }`}
                />
              </div>
              {guids.map((guid, index) => (
                <div
                  key={guid.id}
                  className={`help-button ${styleButton[index]}`}
                  role="button"
                  onClick={() => showAnswer(index, guid)}
                >
                  <span
                    className={`text-danger point-tip ${stylePointCheck(
                      guid.tip,
                      index
                    )}`}
                  >
                    {guid.point}-
                  </span>
                  <span
                    className={`text-white fw-bold ps-1 ${styleTextCheck(
                      guid.tip,
                      index
                    )}`}
                  >
                    {guid.title}
                  </span>
                </div>
              ))}
            </div>
            <PopupBox show={show} setShow={setShow} text={errorText} />
          </div>
          <button
            onClick={() => navigate("/two")}
            className="btn btn-return pt-2 pb-2 mb-4"
          >
            بازگـشـت
          </button>
        </div>
      </div>
    </MasterPage>
  );
};

export default Help2;
